import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PlanosService {

  private httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  constructor(
    private http: HttpClient,
  ) { }

  getPlanos(cnpj: string): Observable<Plano[]> {
    if (cnpj === '') {
      return of();
    }

    return this.http.get<Plano[]>(environment.vendas + '/plano/' + cnpj)
      .pipe(
        catchError(err => of(err.error))
      );
  }

  getPlano(cnpj: string, id: string): Observable<Plano> {
    if (cnpj === '' || id === '') {
      return of();
    }

    return this.http.get<Plano>(environment.vendas + '/plano/' + cnpj + '/' + id)
      .pipe(
        catchError(err => of(err.error))
      );
  }

  updatePlano(cnpj: string, id: string, plano: Plano): Observable<Plano> {
    if (cnpj === '' || id === '' || plano === null) {
      return of();
    }

    return this.http.put<Plano>(environment.vendas + '/plano/' + cnpj + '/' + id, plano, this.httpOptions)
      .pipe(
        catchError(err => of(err.error))
      );
  }
}
